import { del, put, get, post } from '@/lib/api';

export const getJobs = (callback) => {
  return get(`v1/jobs`, {
    action: 'GET_JOBS',
    loader: 'getJobs',
    callback
  });
};

export const getRecentJobLogs = (callback) => {
  return get(`v1/job-logs/latest`, {
    action: 'GET_RECENT_JOB_LOGS',
    loader: 'getRecentJobLogs',
    callback
  });
};

export const postJobManualRun = ({ id, force }, callback) => {
  return post(`v1/jobs/${id}/run`, {
    data: { force, wait: false },
    action: 'POST_JOB_MANUAL_RUN',
    callback
  });
};

export const getJobLogsByJobId = ({ jobId, page = 1 }, callback) => {
  return get(`v1/jobs/${jobId}/logs`, {
    query: { page },
    loader: 'getJobLogsByJobId',
    action: 'GET_JOB_LOGS_BY_JOB_ID',
    callback
  });
};

export const getActiveJobLogsByJobId = ({ jobId }, callback) => {
  return get(`v1/jobs/${jobId}/activeLogs`, {
    loader: 'getActiveJobLogsByJobId',
    action: 'GET_ACTIVE_JOB_LOGS_BY_JOB_ID',
    callback
  });
};

export const getJobLogById = ({ jobId, jobLogId }, callback) => {
  return get(`v1/jobs/${jobId}/logs/${jobLogId}`, {
    action: 'GET_JOB_LOG_BY_ID',
    loader: 'getJobLogById',
    callback
  });
};

export const postJobCompanyConnection = ({ jobId, companyConnectionId }, callback) => {
  return post(`v1/jobs/${jobId}/company-connections/${companyConnectionId}`, {
    callback
  });
};

export const deleteJobCompanyConnection = ({ id, jobId, companyConnectionId }, callback) => {
  return del(`v1/jobs/${jobId}/company-connections/${companyConnectionId}/${id}`, {
    callback
  });
};

export const getJobMemory = ({ id }, callback) => {
  return get(`v1/jobs/${id}/memory`, {
    action: 'GET_JOB_MEMORY',
    callback
  });
};

export const putJobMemory = ({ jobId, key, value }, callback) => {
  return put(`v1/jobs/${jobId}/memory/${key}`, {
    data: {
      value
    },
    action: 'PUT_JOB_MEMORY',
    callback
  });
};

export const deleteJobMemory = ({ jobId, key }, callback) => {
  return del(`v1/jobs/${jobId}/memory`, {
    data: {
      key
    },
    action: 'DELETE_JOB_MEMORY',
    callback
  });
};

export const putJob = ({ id, sourceId, destinationId, status, interval, isDeleted }, callback) => {
  return put(`v1/jobs/${id}`, {
    data: { sourceId, destinationId, status, interval, isDeleted },
    action: 'PUT_JOB',
    callback
  });
};

export const postJob = ({ jobTypeId }, callback) => {
  return post(`v1/jobs`, {
    data: { jobTypeId },
    action: 'POST_JOB',
    callback
  });
};

export const getJobConfig = ({ jobId, jobTypeId }, callback) => {
  return get(`v1/jobs/${jobId}/config`, {
    query: { jobTypeId },
    callback,
    action: 'GET_JOB_CONFIG',
    loader: 'getJobConfig'
  });
};

export const putJobConfig = ({ jobId, jobConfigRefId, id, value }, callback) => {
  return put(`v1/jobs/${jobId}/config/${id}`, {
    data: { value, jobConfigRefId },
    callback,
    action: 'GET_JOB_CONFIG'
  });
};

export const postJobConfigRef = ({ jobTypeId, key, label, datatype, grouping }, callback) => {
  return post(`v1/jobs/config-ref`, {
    data: {
      jobTypeId,
      key,
      label,
      datatype,
      grouping
    },
    callback
  });
};

export const postConnectionConfigRef = ({ connectionId, key, label, datatype, grouping }, callback) => {
  return post(`v1/connections/config-ref`, {
    data: {
      connectionId,
      key,
      label,
      datatype,
      grouping
    },
    callback
  });
};

export const putCompanyConnectionConfig = ({ companyConnectionId, id, value, connectionConfigRefId }, callback) => {
  return put(`v1/company-connections/${companyConnectionId}/config/${id}`, {
    data: { value, connectionConfigRefId },
    callback,
    action: 'GET_JOB_CONFIG'
  });
};

export const putCompanyConnection = ({ companyConnectionId, data }, callback) => {
  return put(`v1/company-connections/${companyConnectionId}`, {
    data,
    callback,
    action: 'PUT_COMPANY_CONNECTION'
  });
};

export const getJobLogOutput = ({ jobLogId }, callback) => {
  return get(`v1/job-logs/${jobLogId}/output`, {
    action: 'GET_JOB_LOG_OUTPUT',
    loader: 'getJobLogOutput',
    callback
  });
};

// export const getJobManagerState = (callback) => {
//   return get(`v1/job-manager/state`, {
//     action: 'GET_JOB_MANAGER_STATE',
//     callback
//   });
// };

// export const putJobManagerState = (data, callback) => {
//   return put(`v1/job-manager/state`, {
//     data,
//     action: 'GET_JOB_MANAGER_STATE',
//     callback
//   });
// };

export const putJobCancel = ({ jobId, jobLogId }, callback) => {
  return put(`v1/jobs/${jobId}/logs/${jobLogId}/cancel`, {
    callback
  });
};

export const getUserJobAlerts = ({ jobId }, callback) => {
  return get(`v1/jobs/${jobId}/alerts`, {
    action: 'PUT_USER_JOB_ALERT',
    callback
  });
};

export const getErroringJobs = (callback) => {
  return get(`v1/jobs/errors`, {
    action: 'GET_ERRORING_JOBS',
    loader: 'getErroringJobs',
    callback
  });
};

export const putUserJobAlert = ({ jobId, alertType, options, isActive }, callback) => {
  return put(`v1/jobs/${jobId}/alerts`, {
    data: {
      alertType,
      options,
      isActive
    },
    action: 'PUT_USER_JOB_ALERT',
    callback
  });
};

export const deleteJobLog = ({ jobId, jobLogId, callback }) => {
  return del(`v1/jobs/${jobId}/logs/${jobLogId}`, {
    action: 'DELETE_JOB_LOG',
    callback,
    meta: {
      jobId,
      jobLogId
    }
  });
};
